import { Box } from '@mui/material';

import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';

import { TourTraveListOutcoming } from './TourTraveListOutcoming';

export function TourTraveListOutcomingEmpty() {
  const fakeTourTravel = buildFakeTourTravel();
  return (
    <Box visibility={'hidden'}>
      <TourTraveListOutcoming
        tourTravels={[fakeTourTravel]}
        onClickDelete={() => {}}
        onClickAdd={() => {}}
        favoriteIds={new Set()}
        onToggleFavorite={() => {}}
        favoriteTravels={[]}
        onCopyTravel={() => {}}
        isWindowFavorite={false}
        onToggleWindowFavorite={() => {}}
        favoriteGroups={[]}
        onCopyGroup={() => {}}
      />
    </Box>
  );
}

function buildFakeTourTravel(): TourTravel {
  return {
    id: 0,
    sequenceId: 0,
    name: '',
    connexionTypeWithEvent: 'outgoing',
    travelDistance: 0,
    fromEventId: undefined,
    fromPosition: undefined,
    toEventId: undefined,
    toPosition: undefined,
  };
}
